import React from 'react';

export default function JourneyLadder({ items, renderItem, ariaLabel }) {
  return (
    <ol className="relative space-y-5 md:space-y-7" aria-label={ariaLabel}>
      <span className="absolute bottom-8 left-5 top-8 w-1 -translate-x-1/2 rounded-full bg-gradient-to-b from-indigo-300 via-violet-300 to-fuchsia-300 md:left-1/2" aria-hidden="true" />
      {items.map((item, index) => {
        const onLeft = index % 2 === 0;
        return (
          <li key={item.id} className="relative grid md:grid-cols-[minmax(0,1fr)_5rem_minmax(0,1fr)] md:items-center">
            <div className={`ml-12 md:ml-0 ${onLeft ? 'md:col-start-1 md:pr-1' : 'md:col-start-3 md:pl-1'}`}>
              {renderItem(item, index)}
            </div>
            <span
              className={`absolute left-5 top-6 z-10 grid h-10 w-10 -translate-x-1/2 place-items-center rounded-full border-4 border-white text-sm font-black text-white shadow-lg md:left-1/2 md:top-1/2 md:-translate-y-1/2 ${item.completed ? 'bg-emerald-500' : 'bg-gradient-to-br from-indigo-500 to-violet-600'}`}
              aria-hidden="true"
            >
              {item.completed ? '✓' : index + 1}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
